import { render, staticRenderFns } from "./settings-contact-property-mapping-pane.vue?vue&type=template&id=a4e2478a&scoped=true"
import script from "./settings-contact-property-mapping-pane.vue?vue&type=script&lang=js"
export * from "./settings-contact-property-mapping-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-contact-property-mapping-pane.vue?vue&type=style&index=0&id=a4e2478a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2478a",
  null
  
)

export default component.exports